var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSawToothWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 182,
    viewBox: "0 0 1920 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-330 91V48L-258.333 134V91V48L-186.667 134V91V48L-115 134V91V48L-43.3333 134V91V48L28.3333 134V91V48L100 134V91L100 48L171.667 134V91V48L243.333 134V91V48L315 134V91V48L386.667 134V91V48L458.333 134V91V48L530 134V91L530 48L601.667 134V91V48L673.333 134V91V48L745 134V91V48L816.667 134V91V48L888.333 134V91V48L960 134V91V48L1031.67 134V91V48L1103.33 134V91V48L1175 134V91V48L1246.67 134V91V48L1318.33 134V91V48L1390 134V91V48L1461.67 134V91V48L1533.33 134V91V48L1605 134V91V48L1676.67 134V91V48L1748.33 134V91V48L1820 134V91V48L1891.67 134V91V48L1963.33 134V91V48L2035 134V91V48L2106.67 134V91V48L2178.33 134V91V48L2250 134V91",
    stroke: "url(#paint0_radial_1081_7733)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1081_7733",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(960 -17.1935) rotate(89.5214) scale(646.4 943.881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D34646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSawToothWave);
export default __webpack_public_path__ + "static/media/sawToothWave.b47fe4c3fb62b5a17692a4d4f6a1289a.svg";
export { ForwardRef as ReactComponent };